import React, {useContext, useRef, useCallback} from 'react';
import styled from 'styled-components';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import BodyTree from './BodyTree';
import {DocumentEngagementIdContext} from '../../../../../Main/Forms/CanvasFormContainer';
import {formBodyType, entities} from '../../../../../../util/uiconstants';
import {FormBodyTypeIdContext} from '../../FormBodyContainer';
import Utility from '../../../../../../util/utilityfunctions';
import {CreateUpdateEntityContainer} from './CreateUpdateEntities/index';
import {useEngagementId, useUserPreferences} from '../../../../../../util/customHooks';

export default function ItControlRelatedObject(props) {
	const {data, isTopLevel, bodyId, isSnapshotView} = props;
	const currentLevel = isTopLevel ? 1 : data.level;
	const engagementId = useEngagementId();
	const documentEngagementId = useContext(DocumentEngagementIdContext);
	const formBodyTypeId = useContext(FormBodyTypeIdContext);

	const userPreferences = useUserPreferences();

	const modalRef = useRef();

	const onClick = useCallback((evt) => {
		if (!isSnapshotView && modalRef.current.toggleModal) {
			evt.stopPropagation();
			modalRef.current.toggleModal();
		}
	}, [modalRef, isSnapshotView]);

	return (
		<StyledItControlRelatedObject
			className={`ItControlRelatedObject entity-content entity-content-level-${currentLevel}
						${formBodyTypeId === formBodyType.RelatedITRiskITProcess ? 'type12' : ''}`}
		>
			<>
				<BodyTree data={data} bodyId={bodyId} formBodyTypeId={formBodyTypeId} defaultOpen open>
					<section
						className={`entity-content-main ItControlRelatedObjectWrapper ${Utility.getClasstoDisableADCLink(
							userPreferences,
							isSnapshotView
						)}`}
					>
						<section className="entity-content-main-name RelatedObjectTextWrapper" onClick={onClick}>
							{currentLevel === 1 && formBodyTypeId === formBodyType.RelatedITRiskITProcess ? (
								<>{Utility.getHtmlTextElement(data.entityName, isSnapshotView)}</>
							) : (
								<EllipsesControl
									content={Utility.getHtmlTextElement(data.entityName, isSnapshotView)}
									tooltip={Utility.getHtmlTextElement(data.entityName, isSnapshotView)}
									noOfLines={1}
								/>
							)}
						</section>
						{data && data.children && data.children.length > 0 && (
							<section className="CountWrapper">
								<span>{Number(data.children.length)}</span>
							</section>
						)}
					</section>
				</BodyTree>
				{!isSnapshotView && (
					<CreateUpdateEntityContainer
						bodyId={bodyId}
						entityId={entities.ItControl}
						entityUId={data?.entityUId}
						entityName={data?.entityName}
						itApproachTypeId={data?.itApproachTypeId}
						engagementId={engagementId}
						documentEngagementId={documentEngagementId}
						forceFetchData
						ref={modalRef}
					/>
				)}
			</>
		</StyledItControlRelatedObject>
	);
}

const StyledItControlRelatedObject = styled.section`
	.tree-trigger-children {
		width: calc(100% - var(--px-20)) !important;
		.ItControlRelatedObjectWrapper {
			align-items: flex-start;
			width: 100%;
			.RelatedObjectTextWrapper {
				max-width: calc(100% - var(--px-40)) !important;
				padding-left: 0 !important;
			}
			.CountWrapper {
				margin-left: var(--px-10);
			}
		}
	}
	&.entity-content {
		&.entity-content-level-1 {
			padding: var(--px-5) var(--px-10) !important;
			&.type14 {
				padding: var(--px-5) 0 !important;
				button {
					.motif-tree-trigger-icon {
						display: none;
					}
				}
				.entity-content-main {
					width: 100% !important;
					.RelatedObjectTextWrapper {
						max-width: calc(100% - var(--px-80)) !important;
					}
					.RelatedRiskIcon {
						display: inline-block;
						margin-right: var(--px-5);
						svg {
							margin-top: 0 !important;
							fill: var(--neutrals-900);
						}
					}
				}
				.entity-content-data {
					display: none;
				}
			}
		}
	}
	&.entity-content.entity-content-level-1 {
		&.type12 {
			padding: var(--px-5) 0 !important;
		}
	}
	&.type12 {
		button {
			.motif-tree-trigger-icon {
				display: none !important;
			}
		}
		.entity-content-main {
			&.ItControlRelatedObjectWrapper {
				width: 100%;
				max-width: 100%;
				&.disableLinksExternalUsers {
					pointer-events: none;
				}
				.RelatedObjectTextWrapper {
					max-width: calc(100% - var(--px-60)) !important;
				}
			}
		}
		.entity-content-level-3 {
			&.ITRiskRelatedObject {
				padding-left: 0 !important;
				border-bottom: var(--px-1) solid var(--neutrals-200);
				margin-left: var(--px-30);
				padding: var(--px-5);
				&:last-child {
					border-bottom: 0;
				}
				.entity-content-main {
					max-width: 100% !important;
					color: inherit;
					cursor: pointer;
					color: var(--blue-600);
				}
			}
		}
	}
	.ItControlRelated {
		svg {
			width: var(--px-20) !important;
			height: var(--px-20) !important;
			margin: 0 !important;
		}
	}
	.ItControlRelatedObjectWrapper {
		.RelatedObjectTextWrapper {
			padding-left: var(--px-20);
			.diffins {
				background-color: #e6ffe6;
				font-family: inherit;
				text-decoration: none;
			}
			.diffdel {
				color: #999;
				background-color: #ffe6e6;
				font-family: inherit;
			}
			.mod {
				background-color: #ffe1ac;
				font-family: inherit;
			}
		}
		&.disableLinksExternalUsers {
			pointer-events: none;
		}
	}
	.motif-tree {
		.ItControlRelatedObjectWrapper {
			.RelatedObjectTextWrapper {
				padding-left: 0;
			}
		}
	}
	&.type14 {
	}
`;
